/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Search_Groups_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search groups" |
*
* @param {Team_Manager_Search_Groups_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_search_groups_placeholder = /** @type {((inputs?: Team_Manager_Search_Groups_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Search_Groups_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher des groupes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppen suchen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca gruppi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поиск групп")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar grupos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索群组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループを検索")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह खोजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pesquisar grupos")
	return /** @type {LocalizedString} */ ("Search groups")
});